import { $, $$ } from '@zimpa/dom';

const TOGGLE_SELECTOR = '.js-collapsable-toggle';
const COLLAPSED_CLASS = 'collapsed';

export function collapsable(): void {
    $$<HTMLElement>(TOGGLE_SELECTOR).forEach((trigger): void => {
        const id = trigger.getAttribute('data-target');
        const className =
            trigger.getAttribute('data-className') ?? COLLAPSED_CLASS;
        const cooc = trigger.getAttribute('data-close-on-outside-click');
        const asModal = trigger.getAttribute('data-as-modal') ?? false;

        if (id === null) {
            return;
        }

        const container: HTMLElement | undefined = $<HTMLElement>(id);

        if (container === undefined) {
            return;
        }

        const triggers: HTMLElement[] = $$<HTMLElement>(
            `[data-target='${id}']`,
        );

        const setMaxHeightProperty = () => {
            const height = container.scrollHeight;
            container.style.setProperty('--max-height', height + 'px');
        };

        window.addEventListener('resize', setMaxHeightProperty);

        const documentClick = (docEvent: MouseEvent) => {
            if (cooc) {
                const target = <HTMLElement>docEvent.target;
                if (target === null) {
                    return;
                }
                if (!target.closest(id)) {
                    trigger.dispatchEvent(new CustomEvent('click'));
                }
            }
        };

        trigger.addEventListener('click', (event): void => {
            setMaxHeightProperty();
            if (container.classList.contains(className)) {
                container.classList.remove(className);
                triggers.forEach((item) => {
                    item.classList.remove(className);
                    item.setAttribute('aria-expanded', 'true');
                });
                container.setAttribute('aria-expanded', 'true');
                container.focus();
                document.body.addEventListener('click', documentClick);
                if (asModal) {
                    document.body.classList.add('modal-open');
                }
            } else {
                container.classList.add(className);
                triggers.forEach((item) => {
                    item.classList.add(className);
                    item.setAttribute('aria-expanded', 'false');
                });
                container.setAttribute('aria-expanded', 'false');
                document.body.removeEventListener('click', documentClick);
                document.body.classList.remove('modal-open');
            }
        });
    });
}
